mutation ResetUserNewMessageCount($input: MessageResetUserNewMessageCountInput!) {
  messageResetUserNewMessageCount(input: $input)  {
    query {
      userMessageUnreadCounts
    }
  }
}
